import {VipConfigVO} from '@/common-pages/vip/vip.service';

export function getCurrentVip(
  list: VipConfigVO[],
  useBaseExp?: boolean,
  baseExp?: number,
) {
  let currentVip = list[list.length - 1];
  let lastVip: VipConfigVO | null = list[list.length - 2];
  for (let i = 0; i < list.length; i++) {
    const item = list[i];
    if (
      useBaseExp &&
      baseExp != null &&
      item.nextLevelExperience != null &&
      baseExp < +item.nextLevelExperience
    ) {
      currentVip = item;
      lastVip = i > 0 ? list[i - 1] : null;
      return {currentVip, lastVip};
    }
    if (
      !useBaseExp &&
      item.currentExperience != null &&
      item.nextLevelExperience != null &&
      +item.currentExperience < +item.nextLevelExperience
    ) {
      currentVip = item;
      lastVip = i > 0 ? list[i - 1] : null;
      return {currentVip, lastVip};
    }
  }
  return {currentVip, lastVip};
}
